import React from 'react';
import { CardContainer } from './styles';
import { CHEVRON_RIGHT_ICON } from '@Images';

type ISelectCardProps = {
  index: number;
  cardIcon: string;
  cardIconText?: string;
  heading: string;
  subHeading: string;
  extraInfo?: string;
  onClick?: () => void;
};

export const SelectCard: React.FC<ISelectCardProps> = (props): React.ReactElement => {
  const { index, cardIcon, cardIconText, heading, subHeading, extraInfo, onClick } = props;
  return (
    <CardContainer key={index} onClick={onClick}>
      <div className="image-container">
        <img src={cardIcon} alt={heading.toLowerCase()} />
        <span className="cardIconText">{cardIconText}</span>
      </div>
      <div className="mid-section-container">
        <span className="heading">{heading}</span>
        <span className="subHeading">{subHeading}</span>
        <span className="extraInfo">{extraInfo}</span>
      </div>

      <div className="rightIconContainer">
        <img src={CHEVRON_RIGHT_ICON} alt="chevron-right" />
      </div>
    </CardContainer>
  );
};
